var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{attrs:{"href":_vm.url}},[_c('base-button',{attrs:{"outline":true,"button-class":"q-px-lg","color":'white',"text-color":'tes-navy-blue-dark',"unelevated":""}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }